import React from 'react';

import { CFColorToken } from '../../theme/tokens/contentful-color';
import { pxToRem } from '../../styles/utils';

import { Text } from '../Text';

interface PlansIconProps {
  name: string;
  title: string;
  textColor: CFColorToken;
  replaceWithText?: string | null;
}

export enum plansEnum {
  CORE = 'Greenlight Core',
  INVEST = 'Greenlight + Invest',
  MAX = 'Greenlight Max',
  INFINITY = 'Greenlight Infinity'
}

export const getRewardByPlan = (name: string) => {
  switch (name) {
    case plansEnum.MAX:
      return 2;

    case plansEnum.INFINITY:
      return 5;

    case plansEnum.CORE:
    case plansEnum.INVEST:
    default:
      return 1;
  }
};

export default function PlansIcon({
  name,
  title,
  textColor,
  replaceWithText
}: PlansIconProps) {
  if (title === 'Greenlight Savings Reward') {
    const percentage = getRewardByPlan(name);

    return (
      <Text
        fontWeight="h3"
        style={{ color: textColor, fontSize: pxToRem(36) }}
        data-testid={`${name}-rewards`}
      >
        {percentage}%
      </Text>
    );
  } else if (name === plansEnum.CORE && replaceWithText) {
    return (
      <Text
        as="h3"
        fontWeight="h3"
        fontSize="h3_tablet"
        data-testid="core-plan-text"
      >
        {replaceWithText}
      </Text>
    );
  } else {
    return (
      <svg
        data-testid={`${name}-${title}`}
        width="32"
        height="22"
        viewBox="0 0 32 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Checkmark"
      >
        <path
          d="M2 10.2051L11.8519 19.9487L30 2"
          stroke={textColor || ('white' as CFColorToken)}
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }
}
